import { render, staticRenderFns } from "./ThePrivacyPolicy.vue?vue&type=template&id=47cbbaea&scoped=true&"
import script from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./ThePrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ThePrivacyPolicy.vue?vue&type=style&index=0&id=47cbbaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbbaea",
  null
  
)

export default component.exports